// extracted by mini-css-extract-plugin
export default {"MenuContainer":"SearchMenu_MenuContainer__J74qh","selectContainer":"SearchMenu_selectContainer__N1XaV","searchField":"SearchMenu_searchField__MTg4N"};